import {z} from 'zod';
import {buildingIdPairSchema} from '@shared/models/building-overview';
import {zNumberToString} from '@brunata-angular/util';

const buildingContext = {
    buildingNo: zNumberToString,
    buildingName: z.string().nullable(),
    buildingAddress: z.string().nullable(),
};

const searchSystemSchema = z.object({
    buildingNo: zNumberToString,
    buildingName: z.string().nullable(),
    address: z.string().nullable(),
    buildingIdPairs: z.array(buildingIdPairSchema),
});

const searchLocationSchema = z.object({
    locationId: zNumberToString,
    proBraLoc: z.string().nullable(),
    address: z.string().nullable(),
    consumerId: zNumberToString.nullable(),
    consumerName: z.string().nullable().optionalUntilDeployed('AGI-17951'),
    ...buildingContext,
});

const searchConsumerSchema = z.object({
    consumerId: zNumberToString,
    consumerNo: z.string().nullable(),
    name: z.string().nullable(),
    email: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    locationId: zNumberToString,
    proBraLoc: z.string().nullable(),
    ...buildingContext,
});

const searchMeterSchema = z.object({
    meterId: zNumberToString,
    meterNo: z.string(),
    secondaryMeterNo: z.string().nullable(),
    printedSerialNo: z.string().nullable(),
    meterModel: z.string().nullable(),
    placement: z.string().nullable(),
    alloUnitType: z.string().nullable(),
    locationId: zNumberToString,
    address: z.string().nullable(),
    ...buildingContext,
});

export const searchResultsSchema = z.object({
    systems: z.object({totalCount: z.number(), items: z.array(searchSystemSchema)}),
    locations: z.object({totalCount: z.number(), items: z.array(searchLocationSchema)}),
    consumers: z.object({totalCount: z.number(), items: z.array(searchConsumerSchema)}),
    meters: z.object({totalCount: z.number(), items: z.array(searchMeterSchema)}),
});

export type SearchResults = z.output<typeof searchResultsSchema>;
export type SearchSystem = z.output<typeof searchSystemSchema>;
export type SearchLocation = z.output<typeof searchLocationSchema>;
export type SearchConsumer = z.output<typeof searchConsumerSchema>;
export type SearchMeter = z.output<typeof searchMeterSchema>;
